<template>
  <div class="form">
    <div class="title">
      <h2>
        <b :style="{ color: '#478bea', fontSize: '30px' }">免费</b>获取课程学费报价
      </h2>
    </div>
    <el-form label-width="60px" :model="formLabelAlign">
      <div class="form-title">姓名</div>
      <el-input
        placeholder="请填写您的姓名"
        v-model="username"
        style="width: 100%"
      ></el-input>
      <div style="width: 100%; height: 10px"></div>
      <div class="form-title">手机号</div>
      <el-input
        placeholder="请填写您的手机号"
        v-model="mobile"
        type="tel"
        style="width: 100%"
      ></el-input>
      <div style="width: 100%; height: 10px"></div>
      <div class="form-title">选择专业</div>
      <div class="form-option">
        <div :class="class1" @click="optionClick(1)">西点烘焙</div>
        <div :class="class2" @click="optionClick(2)">蛋糕甜品</div>
        <div :class="class3" @click="optionClick(3)">咖啡饮品</div>
        <div :class="class4" @click="optionClick(4)">西餐料理</div>
        <div :class="class5" @click="optionClick(5)">精品调酒</div>
        <div :class="class6" @click="optionClick(6)">其他</div>
      </div>
      <div style="width: 100%; height: 10px"></div>
      <el-button
        type="primary"
        :loading="loading"
        style="width: 100%"
        :style="{ background: '#478bea', borderColor: '#478bea' }"
        @click="show"
        round
        >立即免费获取学费</el-button
      ></el-form
    >
     <div style="width: 100%; height: 10px"></div>
    <Vcode :show="isShow" @success="send" @close="close" />
  </div>
</template>

<script>
import { Toast } from "vant";
import Vcode from "vue-puzzle-vcode";

export default {
  data() {
    return {
      username: "",
      mobile: "",
      loading: false,
      buttonWords: this.words,
      bordercolor: this.bordercolor,
      isShow: false,
      major: 1,
      class1: "form-one-on",
      class2: "form-one",
      class3: "form-one",
      class4: "form-one",
      class5: "form-one",
      class6: "form-one",
    };
  },
  watch: {
    mobile: "checkMobile",
  },
  components: {
    Vcode,
  },
  props: {
    color: {
      type: String,
      default: "",
    },
    bag: {
      type: String,
      default: "#ff0000",
    },
    words: {
      type: String,
      default: "立即免费获取学费",
    },
    bordercolor: {
      type: String,
      default: "#ff0000",
    },
  },
  methods: {
    checkMobile() {
      let m = this.mobile;
      let valid_rule =
        /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      if (m.length > 10) {
        if (!valid_rule.test(this.mobile)) {
          Toast.fail("手机号码错误");
          return false;
        }
      }
    },
    show() {
      this.buttonWords = "";
      this.loading = true;
      let valid_rule =
        /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      setTimeout(() => {
        this.loading = false;
        this.buttonWords = "立即免费获取学费";
      }, 1500);
      if (this.username == "" || this.mobile == "") {
        Toast.fail("请完整填写");
        return false;
      } else if (!valid_rule.test(this.mobile)) {
        Toast.fail("手机号码错误");
        return false;
      } else {
        this.isShow = true;
      }
    },
    close() {
      this.isShow = false;
    },
    send() {
      this.isShow = false;
      this.buttonWords = "";
      this.loading = true;
      this.$axios
        .get("http://api.cdomick.com/index.php/form/insert", {
          params: {
            name: this.username,
            mobile: this.mobile,
            laiyuan: document.referrer,
            first: window.location.href,
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.code == 1) {
            Toast.success(response.data.msg);
            window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
            // location.reload();
          } else {
            Toast.success("提交成功");
            window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
            // location.reload();
          }
        })
        .catch(function (error) {
          console.log(error);
          Toast.success("成功");
          this.loading = false;
          this.buttonWords = "立即免费获取学费";
          window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
          location.reload();
        });
    },
    optionClick(a) {
      if (a == 1) {
        this.class1 = "form-one-on";
        this.class2 = "form-one";
        this.class3 = "form-one";
        this.class4 = "form-one";
        this.class5 = "form-one";
        this.class6 = "form-one";
      } else if (a == 2) {
        this.class1 = "form-one";
        this.class2 = "form-one-on";
        this.class3 = "form-one";
        this.class4 = "form-one";
        this.class5 = "form-one";
        this.class6 = "form-one";
      } else if (a == 3) {
        this.class1 = "form-one";
        this.class2 = "form-one";
        this.class3 = "form-one-on";
        this.class4 = "form-one";
        this.class5 = "form-one";
        this.class6 = "form-one";
      } else if (a == 4) {
        this.class1 = "form-one";
        this.class2 = "form-one";
        this.class3 = "form-one";
        this.class4 = "form-one-on";
        this.class5 = "form-one";
        this.class6 = "form-one";
      } else if (a == 5) {
        this.class1 = "form-one";
        this.class2 = "form-one";
        this.class3 = "form-one";
        this.class4 = "form-one";
        this.class5 = "form-one-on";
        this.class6 = "form-one";
      } else if (a == 6) {
        this.class1 = "form-one";
        this.class2 = "form-one";
        this.class3 = "form-one";
        this.class4 = "form-one";
        this.class5 = "form-one";
        this.class6 = "form-one-on";
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-input__inner {
  border: 1px solid #86868b;
  border-radius: 9px;
}
.title {
  width: 100%;
  padding: 20px 0;
}
.form {
  width: 100%;
  padding: 0 10px;
  text-align: center;
}

.form-title {
  width: 100%;
  height: 12px;
  font-size: 14px;
  text-align: left;
  font-weight: 600;
}
.form-option {
  width: 100%;
  height: 160px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.form-one {
  width: 49%;
  height: 40px;
  border: 1px solid #86868b;
  margin-bottom: 10px;
  border-radius: 9px;
  line-height: 39px;
  text-align: center;
  font-size: 16px;
}
.form-one-on {
  width: 49%;
  height: 40px;
  border: 1px solid #478bea;
  color: #478bea;
  margin-bottom: 10px;
  border-radius: 9px;
  line-height: 39px;
  text-align: center;
  font-size: 16px;
}
</style>
